export const COLORS = {
	PRIMARY: 'rgb(245,129,52)',
	PRIMARY__HEX: '#F58134',
	PRIMARY2: 'rgb(183,188,193)',
	SECONDARY: 'rgb(44,76,84)',
	SECONDARY__HEX: '#2C4C54',
	SECONDARY2: 'rgb(104,130,147)',
	SECONDARY2__HEX: '#688293',
	LINK: 'rgb(42, 120, 184)',
	LINK__HEX: '#2a78b8',
	BORDER: 'rgb(238,238,238)',
	BORDER_TABLE_ROW: 'rgb(230,230,230)',
	BORDER_TABLE_ROW_DARK: 'rgb(220,220,220)',
	BACKGROUND: 'rgb(250,250,250)',
	BACKGROUND_GREY_DARK: 'rgb(77,85,85)',
	BACKGROUND_GREY_LIGHT: 'rgb(240,240,240)',
	BACKGROUND_INPUT: 'rgb(243,244,245)',
	BACKGROUND_INPUT_HOVER: 'rgb(232,232,232)',
	BACKGROUND_SEARCH: 'rgb(235,235,235)',
	TEXT_SECONDARY: 'rgba(0,0,0,.6)',
	WHITE: 'rgb(255,255,255)'
};

export const DIMENSIONS = {
	FILTERS_PANEL_WIDTH: 290,
	FILTERS_PANEL_MIN_WIDTH: 200,
	NAVBAR_HEIGHT: 64,
	NAVBAR_HEIGHT_XS: 58,
	SEARCHBAR_HEIGHT: 44,
	SELECT_MENU_ITEM_HEIGHT: 36,
	SKELETON_BUTTON_WIDTH: 130,
	SKELETON_BUTTON_HEIGHT: 44,
	SKELETON_TABLE_ROW_HEIGHT: 80,
	SKELETON_TEXT_HEIGHT: 30,
	SKELETON_TITLE_HEIGHT: 38
};

export const FONT_FAMILIES = ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(',');

export const FONT_SIZES = {
	ONSEMI_TITLE: 'calc(1.375rem + 1.5vw)',
	H1: '2.5rem', // 40px
	H2: '2.125rem', // 34px
	H3: '1.875rem', // 30px
	H4: '1.675rem', // 26px
	H5: '1.375rem', // 22px
	H6: '1.125rem', // 18px
	SUBTITLE1: '1rem', // 16px
	SUBTITLE2: '0.938rem', // 15px
	BODY1: '0.875rem', // 14px
	BODY2: '0.813rem', // 13px
	CAPTION: '0.688rem' // 11px
};

export const SPACING = 3;

export const NUMBER_OF_SKELETON_TABLE_ROWS = 8;
export const NUMBER_OF_SKELETON_TABLE_FILTERS_ROWS = 10;
